import { ReactNode, useState } from 'react';

import clsx from 'clsx';
import { useResizeDetector } from 'react-resize-detector';

/**
 * Text truncate <p> component
 */
export default function Truncate({
  children,
  lines,
  startExpanded = false,
  enableExpand = false,
  enableCollapse = false,
  className,
}: {
  lines: number;
  children: ReactNode;
  startExpanded?: boolean;
  enableExpand?: boolean;
  enableCollapse?: boolean;
  className?: string;
}) {
  const { height, ref } = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 500,
  });
  const [expanded, setExpanded] = useState<boolean>(startExpanded);
  const isTruncated = ref?.current?.scrollHeight > height + 4; // +1 to allow for rounding

  return (
    <>
      <p
        style={{
          maxWidth: '100%',
          width: '100%',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: expanded ? 99999 : lines,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          position: 'relative',
          // break on line breaks
          whiteSpace: 'pre-line',
        }}
        ref={ref}
        className={clsx(className, 'mb-0')}
      >
        {children}
      </p>
      <span className="p-0 m-0">
        {!expanded && isTruncated && enableExpand && (
          <button
            onClick={() => setExpanded(true)}
            className="btn btn-link small letter-spacing-1 text-lowercase py-0 bg-white ps-1"
          >
            ...show more
          </button>
        )}

        {expanded && enableCollapse && (
          <button
            onClick={() => setExpanded(false)}
            className="btn btn-link small letter-spacing-1 text-lowercase py-0 bg-white ps-1"
          >
            ...show less
          </button>
        )}
      </span>
    </>
  );
}
